// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables(input) {
  return {
    input: input
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_validatePropertyAddress(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "PropertyAddressValidated",
    "ValidatePropertyAddressDuplicatePropertyError",
    "ValidatePropertyAddressGeocodingError"
  ]);
}

let variablesConverter = {"validatePropertyAddressInput":{},"__root":{"input":{"r":"validatePropertyAddressInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"validatePropertyAddress_ValidatePropertyAddressDuplicatePropertyError_property_createdAt":{"b":""},"validatePropertyAddress_ValidatePropertyAddressDuplicatePropertyError_property":{"f":""},"validatePropertyAddress":{"u":"response_validatePropertyAddress"}}};

let wrapResponseConverterMap = {
  response_validatePropertyAddress: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"validatePropertyAddress_ValidatePropertyAddressDuplicatePropertyError_property_createdAt":{"b":""},"validatePropertyAddress_ValidatePropertyAddressDuplicatePropertyError_property":{"f":""},"validatePropertyAddress":{"u":"response_validatePropertyAddress"}}};

let responseConverterMap = {
  response_validatePropertyAddress: unwrap_response_validatePropertyAddress
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function geocodingErrorReason_decode($$enum) {
  if ($$enum === "INCOMPLETE_ADDRESS" || $$enum === "UNABLE_TO_GEOCODE" || $$enum === "OUTSIDE_CHAPTER_BOUNDARIES" || $$enum === "POOR_GEOCODING_ACCURACY") {
    return $$enum;
  }
}

let geocodingErrorReason_fromString = geocodingErrorReason_decode;

function propertyOwnerClientType_decode($$enum) {
  if ($$enum === "LANDLORD" || $$enum === "SELLER") {
    return $$enum;
  }
}

let propertyOwnerClientType_fromString = propertyOwnerClientType_decode;

let Utils = {
  geocodingErrorReason_decode: geocodingErrorReason_decode,
  geocodingErrorReason_fromString: geocodingErrorReason_fromString,
  propertyOwnerClientType_decode: propertyOwnerClientType_decode,
  propertyOwnerClientType_fromString: propertyOwnerClientType_fromString
};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "CoordinatesV5",
  "kind": "LinkedField",
  "name": "coordinates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lon",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "PropertyAddressValidatedStandardizedAddress",
  "kind": "LinkedField",
  "name": "standardizedAddress",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "zip",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    }
  ],
  "type": "ValidatePropertyAddressGeocodingError",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v12 = [
  (v7/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Area",
    "kind": "LinkedField",
    "name": "area",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      (v11/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GeocodingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "validatePropertyAddress",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Area",
                "kind": "LinkedField",
                "name": "displayNeighborhoods",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "type": "PropertyAddressValidated",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "property",
                  "plural": false,
                  "selections": [
                    (v2/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PropertyAddressValidationDuplicatePropertyError_property"
                    },
                    (v4/*: any*/),
                    (v9/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "client",
                      "plural": false,
                      "selections": [
                        (v2/*: any*/),
                        (v4/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                "action": "THROW"
              }
            ],
            "type": "ValidatePropertyAddressDuplicatePropertyError",
            "abstractKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GeocodingQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "validatePropertyAddress",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Area",
                "kind": "LinkedField",
                "name": "displayNeighborhoods",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v11/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "type": "PropertyAddressValidated",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "property",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isEditableProperty"
                  },
                  (v4/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "client",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v12/*: any*/),
                    "type": "EditableQuietProperty",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v12/*: any*/),
                    "type": "EditableBroadcastForSaleProperty",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v12/*: any*/),
                    "type": "EditableBroadcastRentalProperty",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "ValidatePropertyAddressDuplicatePropertyError",
            "abstractKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c91df2016384720530ff75226a1b4208",
    "id": null,
    "metadata": {},
    "name": "GeocodingQuery",
    "operationKind": "query",
    "text": "query GeocodingQuery(\n  $input: ValidatePropertyAddressInput!\n) {\n  validatePropertyAddress(input: $input) {\n    __typename\n    ... on PropertyAddressValidated {\n      coordinates {\n        lat\n        lon\n      }\n      displayNeighborhoods {\n        __typename\n        id\n        label\n        nodeId\n      }\n      standardizedAddress {\n        address\n        city\n        state\n        zip\n      }\n    }\n    ... on ValidatePropertyAddressDuplicatePropertyError {\n      property {\n        __typename\n        ...PropertyAddressValidationDuplicatePropertyError_property\n        id\n        createdAt\n        client {\n          __typename\n          id\n          nodeId\n        }\n      }\n    }\n    ... on ValidatePropertyAddressGeocodingError {\n      reason\n    }\n  }\n}\n\nfragment DuplicateBroadcastForSalePropertyError_editableBroadcastForSaleProperty on EditableBroadcastForSaleProperty {\n  id\n  address\n  area {\n    label\n    nodeId\n  }\n  client {\n    __typename\n    id\n    nodeId\n  }\n  createdAt\n}\n\nfragment DuplicateBroadcastRentalPropertyError_editableBroadcastRentalProperty on EditableBroadcastRentalProperty {\n  id\n  address\n  area {\n    label\n    nodeId\n  }\n  client {\n    __typename\n    id\n    nodeId\n  }\n  createdAt\n}\n\nfragment DuplicateQuietPropertyError_quietProperty on EditableQuietProperty {\n  id\n  address\n  area {\n    label\n    nodeId\n  }\n  client {\n    __typename\n    id\n    nodeId\n  }\n  createdAt\n}\n\nfragment PropertyAddressValidationDuplicatePropertyError_property on EditableProperty {\n  __isEditableProperty: __typename\n  __typename\n  ... on EditableQuietProperty {\n    ...DuplicateQuietPropertyError_quietProperty\n  }\n  ... on EditableBroadcastForSaleProperty {\n    ...DuplicateBroadcastForSalePropertyError_editableBroadcastForSaleProperty\n  }\n  ... on EditableBroadcastRentalProperty {\n    ...DuplicateBroadcastRentalPropertyError_editableBroadcastRentalProperty\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

let wrap_response_validatePropertyAddress = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_validatePropertyAddress = unwrap_response_validatePropertyAddress;
exports.wrap_response_validatePropertyAddress = wrap_response_validatePropertyAddress;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
